function __$styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

import { Component } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var FetchStatus;
(function (FetchStatus) {
    // Initial = 'initial',
    FetchStatus["Loading"] = "loading";
    FetchStatus["Completed"] = "completed";
    // Updating = 'updating',
    FetchStatus["Error"] = "error";
})(FetchStatus || (FetchStatus = {}));
//# sourceMappingURL=FetchStatus.js.map

//# sourceMappingURL=index.js.map

var ReactAsyncData = /** @class */ (function (_super) {
    __extends(ReactAsyncData, _super);
    function ReactAsyncData(props) {
        var _this = _super.call(this, props) || this;
        _this.getData = _this.getData.bind(_this);
        _this.startTimer = _this.startTimer.bind(_this);
        _this.safeStopTimer = _this.safeStopTimer.bind(_this);
        _this.state = {
            status: FetchStatus.Loading,
            fetchId: props.fetchId
        };
        return _this;
    }
    ReactAsyncData.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeout;
            return __generator(this, function (_a) {
                timeout = this.props.timeout;
                if (timeout) {
                    this.startTimer(timeout);
                }
                else {
                    this.getData();
                }
                return [2 /*return*/];
            });
        });
    };
    ReactAsyncData.prototype.componentWillUnmount = function () {
        this.safeStopTimer();
    };
    ReactAsyncData.prototype.componentWillReceiveProps = function (_a) {
        var fetchId = _a.fetchId, timeout = _a.timeout;
        return __awaiter(this, void 0, void 0, function () {
            var currentFetchId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentFetchId = this.state.fetchId;
                        if (!(fetchId !== currentFetchId)) return [3 /*break*/, 2];
                        this.setState({ fetchId: fetchId });
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.timer && timeout) {
                            this.startTimer(timeout);
                        }
                        else if (this.timer && !timeout) {
                            this.safeStopTimer();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReactAsyncData.prototype.startTimer = function (timeout) {
        var _this = this;
        this.getData();
        this.timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.getData()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }, timeout);
    };
    ReactAsyncData.prototype.safeStopTimer = function () {
        if (!this.timer) {
            return;
        }
        clearInterval(this.timer);
        this.timer = null;
    };
    ReactAsyncData.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fetch, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetch = this.props.fetch;
                        this.setState({ status: FetchStatus.Loading, error: undefined });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch()];
                    case 2:
                        data = _a.sent();
                        this.setState({ data: data, status: FetchStatus.Completed });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({
                            error: error_1,
                            status: FetchStatus.Error,
                            data: undefined
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReactAsyncData.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, data = _a.data, status = _a.status;
        return children({
            data: data,
            status: status
        });
    };
    return ReactAsyncData;
}(Component));

export default ReactAsyncData;
export { FetchStatus };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 3
// module chunks = 0